import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DeviceConfiguredApplicationsEffects } from './device-configured-applications.effects';
import { deviceConfiguredApplicationsReducer } from './device-configured-applications.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('device-configured-applications', deviceConfiguredApplicationsReducer),
    EffectsModule.forFeature([DeviceConfiguredApplicationsEffects]),
  ],
  providers: [],
})
export class DeviceConfiguredApplicationsStoreModule {}
